export default "__VITE_ASSET__ojcKZOLW__"